import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { Button, makeStyles } from '@ellucian/react-design-system/core';
import { colorGlobalBorderDefault, spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: spacing40,
        border: `1px solid ${colorGlobalBorderDefault}`,
    },
    trashIcon: {
        marginLeft: spacing40,
    }
}));
const RepeatingSectionAddButton = props => {
    const intl = useIntl();
    const {
        onClick,
    } = props;
    const classes = useStyles();
    const [announcement, setAnnouncement] = useState('');

    const handleClick = () => {
        onClick();
        setAnnouncement(intl.formatMessage({ id: 'repeatingSectionAdded' }));
    };

    return (
        <div className={classes.root}>
            <Button
                aria-label={intl.formatMessage({ id: 'applicationFormAdd' })}
                onClick={handleClick}
                variant="text"
            >
                <FormattedMessage id="applicationFormAdd"/>
            </Button>
            <div aria-live="polite" style={{ position: 'absolute', left: '-9999px' }}>
                {announcement}
            </div>
        </div>
    );
};
RepeatingSectionAddButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};
export default RepeatingSectionAddButton;
